import { connect } from "react-redux";

var Glyphicon = require("components/utility/icons/Glyphicon");
var Formats = require("lib/academic/Formats");
var Skillsets = require("lib/academic/Skillsets");
var TextTypes = require("lib/academic/TextTypes");
var ReactTooltip = require("react-tooltip");
var BookDisplay = require("components/reading/books/BookDisplay")

var WritingSelectors = require("lib/selectors/WritingSelectors");
var UIActions = require("lib/actions/UIActions");
var WritingActions = require("lib/actions/WritingActions");

require("writing/activities/exercise_tile.scss")

@connect(
	(state, props) => {
		var requiredRecords = {}

		// We'll sometimes end up setting values more than once
		if (props.responseID) {
			var response = WritingSelectors.response({ state, id: props.responseID });
			requiredRecords.response = response;
			requiredRecords.activity = WritingSelectors.activity({ state, id: response.activity_id });
		}

		if (props.taskID) {
			var task = WritingSelectors.task({ state, id: props.taskID });
			requiredRecords.task = task;
			requiredRecords.activity = WritingSelectors.activity({ state, id: task.subject_id })
			if (task.completion_id) {
				requiredRecords.response = WritingSelectors.response({ state, id: task.completion_id });
			}
		}
		return requiredRecords;
	}, 
	(dispatch, props) => {
		var handlers = {};

		if (props.allowExpandResponse && props.responseID) {
			handlers.onClick = (response) => {
				if (response.draft) {
					$wr.redirect("/responses/new?text_id=" + response.text_id + '&activity_id=' + response.activity_id);
				} else {
					dispatch(UIActions.toggleExpandedResponse({ responseID: props.responseID, expanded: true }));
				}
			}
		}
		if (props.allowRemoveTask && props.taskID && !props.responseID) {
			handlers.onRemoveTask = () =>
				dispatch(WritingActions.deleteTask({ id: props.taskID }))
		}

		return handlers;
	}
)

class ExerciseTile extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onTileClick(e) {
		$wr.nope(e)
		if (this.props.onClick) {
			this.props.onClick(this.props.response);
		} else {
			var url = "/responses/new?activity_id=" + this.props.activity.id;
			// $wr.redirect(url;
			window.open(url, "_blank");
		}
	}

	onRemoveTask(e) {
		if (e) {
			e.stopPropagation();
			$wr.nope(e)
		}
		if (this.props.onRemoveTask) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Exercise Unassigned", text: "You have unassigned the exercise.", icon: "trash" });
			this.props.onRemoveTask();
		}
	}

	onOpenPrintable(e) {
		$wr.nope(e)
		var activity = this.props.activity;

		Mycroft.newEvent({ category: "Printables", action: "view-activitiy", label: activity.key });
		setTimeout(function() {
			Mycroft.newEvent({ category: "Printables", action: "view-skillset", label: activity.format_summary.skillset });
		}, 1100);
		setTimeout(function() {
			Mycroft.newEvent({ category: "Printables", action: "view-format", label: activity.format_summary.format_class });
		}, 2200);

		window.open(activity.thumbnail.printable_url, "_blank");
	}

	render() {
		var { response, activity, task } = this.props;

		if (response) {
			if (response.text_id && response.text_id !== 'MISSING_TEXT_ID') {
				var textInfo = (
					<div className="bookTitle">
						For: <BookDisplay textID={ response.text_id } />
					</div>
				)
			} else {
				var textInfo = (
					<div className="bookTitle">
						<em>Text provided</em>
					</div>
				)
			}

			if (response.edited_at) {
				var editedLine = (
					<span className="date">
						Edited: { $wr.formatDate(response.edited_at) }
					</span>
				);
			}
			if (response.completed_at) {
				var completedLine = (
					<span className="date">Completed: { $wr.formatDate(response.created_at) }</span>
				)
			}
		}

		if (task) {
			if (task.created_at) {
				var assignedLine = (
					<span className="date">Assigned: { $wr.formatDate(task.created_at) }</span>
				)				
			}

			if (this.props.onRemoveTask && !response) {
				var removeFlag = (
					<li onClick={ this.onRemoveTask } className="dynamic assignMarker clickableElement">
						<span className="buttonTitle">Unassign</span>
						<Glyphicon icon="minus" className="menuIcon" />
					</li>
				);
			}

			if (this.props.showCompleted && response) {
				var completedFlag = (
					<li onClick={ this.onRemoveTask } className="completedMarker">
						<span className="buttonTitle">Completed</span>
						<Glyphicon icon="ok" className="menuIcon" />
					</li>
				);
			}
		}

		var activityTitleClassName = "activityTitle"
		if (response && response.draft) {
			var draftMessage = (
				<span><br /><em>Unfinished</em></span>
			);
		}


		var textContent = ( 
			<div className="responseInfo smallText">
				<div className="responseHeader">
					<p className={ activityTitleClassName }>
						<strong>{ activity.format_summary.title }</strong>
						{ draftMessage }
					</p>
				</div>	
				<div className="responseBody">
					{ textInfo }
					{ assignedLine }
					{ completedLine }
					{ editedLine }
				</div>
			</div>
		);

		var className = "tile exerciseTile";
		if (this.props.onClick) {
			className += " clickableElement";
		}

		var skillset = activity.format_summary.skillset;

		var imgContainerClassName = "imgContainer";
		if (this.props.smallThumbnail) {
			imgContainerClassName += " small";
		}

		var printControl = (
			<li onClick={ this.onOpenPrintable } className="dynamic printMarker">
				<span className="buttonTitle">Print</span>
				<Glyphicon icon="print" className="menuIcon" />
			</li>
		);

		return (
			<div className={ className }>
				<div className={ imgContainerClassName }>
					<div className="buttonsBar">
						<ul>
							{ removeFlag }
							{ completedFlag }
							{ printControl }
						</ul>
					</div>
					<img src={ activity.thumbnail.url } className="tileImg" onClick={ this.onTileClick } />
				</div>
				{ textContent }
				<div className="skillsetTitle smallText">
					<img src={ Skillsets.getIcon(skillset) } className="skillsetImg" />
					<span className="itemName">
						{ Skillsets.getName(skillset) }
					</span>
				</div>
			</div>
		)
	}
};

ExerciseTile.WrappedComponent.propTypes = StrictPropTypes({

	// One of these must be set, but any are sufficient to show this tile
	responseID: PropTypes.number,
	activityID: PropTypes.number,
	taskID: PropTypes.number,

	// If set, limits the height of the image of the activity
	smallThumbnail: PropTypes.bool,
	
	// If set, clicking on the tile will open a modal showing the response 
	allowExpandResponse: PropTypes.bool,

	// If set, show a flag to indicated the task has been completed (if it's been completed) 
	showCompleted: PropTypes.bool,

	// If set, included a button to remove the task
	allowRemoveTask: PropTypes.bool,

	allowPreview: PropTypes.bool,

	// Data from @connect:
	activity: PropTypes.object.isRequired,
	response: PropTypes.object,
	task: PropTypes.object,

	// Handlers from @connect:
	onClick: PropTypes.func,
	onRemoveTask: PropTypes.func,
});

module.exports = ExerciseTile;



// WEBPACK FOOTER //
// ./modules/components/writing/activities/ExerciseTile.js